import { useContext } from "react";
import OnlineOrderValuesModel from "../../../../services/models/formModels/onlineOrderValues.model";
import useOrganizations from "../../../../services/utils/custom hooks/useOrganizations";
import usePhysiciansOfOrg from "../../../../services/utils/custom hooks/usePhysiciansOfOrg";
import CustomText from "../../../atomic/CustomText";
import DetailRenderer from "../DetailRenderer";
import { ApplicationState } from "../../../../services/context/ApplicationStateContext";

function ClinicianInformationReview({
  values,
}: {
  values: OnlineOrderValuesModel;
}): JSX.Element {
  const {
    state: { selectedOrganization, selectedPhysician },
  } = useContext(ApplicationState);
  const { data: organizationsData } = useOrganizations();
  const { data: physiciansData } = usePhysiciansOfOrg();
  const org = organizationsData?.data.find(
    (org) => org.id === selectedOrganization
  );
  const clinician: any = physiciansData?.data.find(
    (clinician) => clinician.id === selectedPhysician
  );

  return (
    <div>
      <CustomText
        text="CLINICIAN Information"
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />
      <div className="reviewCard">
        <DetailRenderer
          data={{
            name: org?.name,
            address: org?.address,
            city: org?.city,
            state: org?.state,
            zipcode: org?.zipcode,
            phone: org?.phone,
            fax: org?.fax,
          }}
          groupFields={[
            "name",
            "address",
            "city",
            "state",
            "zipcode",
            "phone",
            "fax",
          ]}
          hiddenFields={[]}
          MainHeading="Organization"
        />
        <DetailRenderer
          data={{
            firstName: clinician?.firstName,
            lastName: clinician?.lastName,
            suffix: clinician?.suffix,
            npi: clinician?.npi,
            specialty: clinician?.specialty,
            email: clinician?.email,
          }}
          groupFields={[
            "firstName",
            "lastName",
            "suffix",
            "npi",
            "specialty",
            "email",
          ]}
          hiddenFields={[]}
          MainHeading="Contact Info"
        />
      </div>
    </div>
  );
}
export default ClinicianInformationReview;
